import * as tslib_1 from "tslib";
import getSharingInformation from '../actions/getSharingInformation';
import { onSharePointLinkDetected } from '../actions/internalActions';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { beautifySharingLink } from 'owa-compose-link';
import { getDisplayDateFromEwsDate } from 'owa-datetime/lib/displaydate/getDisplayDateFromEwsDate';
import { now } from 'owa-datetime/lib/displaydate/now';
import formatShortMonthDayYearFormat from 'owa-datetime/lib/formatters/formatShortMonthDayYearFormat';
import { getIconForFile } from 'owa-file-icon';
import { getAttachmentPermissionLevelFromSharingLinkKind } from 'owa-link-data';
import { getSharingLink } from 'owa-link-data';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import { isGuestUrlPermissionLevel, isValidGetSharingInfoResponse } from 'owa-sharing-data';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { trace } from 'owa-trace';
import { COMPOSE_ONLY_ATTACHMENT_CONTENT_END, COMPOSE_ONLY_ATTACHMENT_CONTENT_START, } from 'owa-attachment-link-common';
var classNames = require('classnames/bind');
export default function handleSharePointLink(linkPlugin, shouldBeautifyLink, anchorElement, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var addedElements, response, hasValidFileName, sharingLink, isValidResponse, permissionLevel;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trace.info('LinkPlugin.handleSharePointLink');
                    logUsage(datapoints.AttachmentComposeSPLinks.datapoint.name);
                    if (shouldBeautifyLink) {
                        // Spinner is only needed when we will beautify the link
                        addedElements = displaySpinner(anchorElement);
                        logUsage(datapoints.AttachmentComposeSPLinksShouldReplaceText.datapoint.name);
                    }
                    return [4 /*yield*/, getSharingInformation(anchorElement.href)];
                case 1:
                    response = _a.sent();
                    if (!linkPlugin.editor) {
                        // This plugin has been disposed. No need to do anything
                        return [2 /*return*/];
                    }
                    onSharePointLinkDetected(anchorElement.id, viewState.sharingLinkIds, response, viewState, parentItemIdWrapper.itemId, infoBarAddHandler, infoBarRemoveHandler);
                    // Remove spinner and replace text when conditions are met.
                    if (shouldBeautifyLink) {
                        removeSpinner(anchorElement, addedElements);
                        hasValidFileName = response && response.FileName && response.FileName.length > 0;
                        sharingLink = getSharingLink(anchorElement.id);
                        if (hasValidFileName) {
                            if (!isAttachmentFeatureEnabled('doc-links-view')) {
                                displayFileIconAndName(anchorElement, response.FileName, response.MimeType, response.ExpirationDate);
                            }
                            logUsage(datapoints.AttachmentComposeSPLinksResponseHasValidFileName.datapoint.name);
                        }
                        isValidResponse = isValidGetSharingInfoResponse(response);
                        if (isValidResponse) {
                            if (isAttachmentFeatureEnabled('doc-sharingTips-linkRemove') &&
                                isAttachmentFeatureEnabled('doc-links-view')) {
                                beautifySharingLink(linkPlugin.editor, anchorElement, sharingLink, isValidResponse, hasValidFileName, response.MimeType);
                            }
                            else {
                                highlightBackground(anchorElement);
                                permissionLevel = getAttachmentPermissionLevelFromSharingLinkKind(response.SharingLinkKind);
                                if (!response.CanShareInternally && !isGuestUrlPermissionLevel(permissionLevel)) {
                                    displayErrorIcon(anchorElement);
                                }
                            }
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
var linkStyles = require('owa-compose-link/lib/components/Link.scss');
function displaySpinner(anchorElement) {
    var spinnerContainer = document.createElement('img');
    spinnerContainer.src = getPackageBaseUrl() + "resources/images/spinner_16.gif";
    spinnerContainer.className = linkStyles.linkSpinner;
    var newElements = [];
    newElements.push(document.createComment(COMPOSE_ONLY_ATTACHMENT_CONTENT_START));
    newElements.push(spinnerContainer);
    newElements.push(document.createComment(COMPOSE_ONLY_ATTACHMENT_CONTENT_END));
    newElements.forEach(function (newElement) {
        anchorElement.appendChild(newElement);
    });
    return newElements;
}
function removeSpinner(anchorElement, addedElements) {
    addedElements.forEach(function (element) {
        try {
            anchorElement.removeChild(element);
        }
        catch (Exception) {
            // In case user has removed the spinner
        }
    });
}
function displayFileIconAndName(anchorElement, fileName, mimeType, expirationDate) {
    anchorElement.text = fileName;
    if (!isAttachmentFeatureEnabled('doc-sharingTips-linkRemove')) {
        return;
    }
    if (expirationDate) {
        if (now().getTime() < new Date(expirationDate).getTime()) {
            var formattedExpirationDate = getDisplayDateFromEwsDate(expirationDate);
            anchorElement.text = format(strings.expiringLinkText, anchorElement.text, formatShortMonthDayYearFormat(formattedExpirationDate));
        }
        else {
            anchorElement.className = classNames(anchorElement.className, linkStyles.linkWithSharingIssue);
            anchorElement.text = format(strings.expiredLinkText, anchorElement.text);
        }
    }
    var fileIcon = getIconForFile(fileName, mimeType === 'text/directory', mimeType);
    if (!fileIcon.cdn) {
        return;
    }
    var iconContainer = document.createElement('img');
    iconContainer.src = fileIcon.cdn;
    iconContainer.style.width = '16px';
    iconContainer.style.height = '16px';
    iconContainer.style.verticalAlign = 'middle';
    iconContainer.style.paddingRight = '2px';
    anchorElement.insertAdjacentElement('afterbegin', iconContainer);
    anchorElement.style.whiteSpace = 'nowrap';
}
function highlightBackground(anchorElement) {
    if (!isAttachmentFeatureEnabled('doc-sharingTips-linkRemove')) {
        return;
    }
    anchorElement.style.backgroundColor = 'rgb(244,244,244)';
    anchorElement.style.borderRadius = '2px';
    anchorElement.style.padding = '0 2px 0 2px';
}
function displayErrorIcon(anchorElement) {
    if (!isAttachmentFeatureEnabled('doc-sharingTips-linkRemove')) {
        return;
    }
    var errorIconContainer = document.createElement('img');
    errorIconContainer.src = getPackageBaseUrl() + "resources/images/redinfo_24.png";
    errorIconContainer.style.width = '12px';
    errorIconContainer.style.height = '12px';
    errorIconContainer.style.verticalAlign = 'top';
    anchorElement.appendChild(document.createComment(COMPOSE_ONLY_ATTACHMENT_CONTENT_START));
    anchorElement.appendChild(errorIconContainer);
    anchorElement.appendChild(document.createComment(COMPOSE_ONLY_ATTACHMENT_CONTENT_END));
    anchorElement.className = classNames(anchorElement.className, linkStyles.linkWithSharingIssue);
}
//# sourceMappingURL=handleSharePointLink.js.map